import { useEffect, useRef } from 'react';

/** Which drag-and-drop props a list has: `reorder`, `outgoing`, `incoming`. */
type DndPresence = { reorder: boolean; outgoing: boolean; incoming: boolean };

/**
 * Dev only: a list whose drag-and-drop props come or go after it mounted re-creates all its tiles
 * (`TileCollection` keys its list on them), which shows as a flash. Logs each switch once, naming
 * the list, so the host keeps the props and ignores the drop instead.
 */
export function useDndPresenceGuard(
  label: string,
  presence: DndPresence
): void {
  const seen = useRef<DndPresence | null>(null);
  useEffect(() => {
    if (!import.meta.env.DEV) return;
    const before = seen.current;
    seen.current = presence;
    if (before === null) return;
    const switched = (Object.keys(presence) as (keyof DndPresence)[]).filter(
      name => before[name] !== presence[name]
    );
    if (switched.length > 0) {
      console.warn(
        `[TileCollection] "${label}": ${switched.join(', ')} switched after mounting; every tile re-mounts`
      );
    }
  });
}
